import { z } from "zod";

export const SerialKillerStatusZ = z.enum(["alive", "dead", "imprisoned", "unknown"]);
export type SerialKillerStatus = z.infer<typeof SerialKillerStatusZ>;